import React, {useCallback} from 'react';
import EffectParameterSlider from '../EffectParameterSlider.js';

export default ({macros, setShowMacrosView, sequencerEngine}) => {
    const onClick = useCallback(() => {
        setShowMacrosView(false);
    }, [setShowMacrosView]);
    return (
        <div className="effect-rack macros-view">
          {macros.map(
              macro => 
                  <EffectParameterSlider
                    effectNumber={0}
                    automation={undefined}
                    name={macro.name}
                    selectedParameter={undefined}
                    sequencerEngine={sequencerEngine}
                    lfoEnabled={true}
                    root={3}
                    parameter={macro.macroParameter}
                    isParameter={true}
                    onParameterChanged={() => []}
                    step={0.01}
                    max={1}
                    min={0}
                  />
          )}
          <div
            onClick={onClick}
            className="expand-macros-button">
            Expand
          </div>
        </div>
    );
};
